// extracted by mini-css-extract-plugin
module.exports = {"image":"_3fDTKRO","imageUpload":"_2ka4ScU"};